import { HTMLAttributes } from "react";

export default function Nginx(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2332_1999)">
        <path
          d="M3.50531 35.9896C3.72304 36.3767 4.0376 36.6672 4.4249 36.8849L23.0578 47.6292C23.8322 48.0889 24.7759 48.0889 25.5261 47.6292L44.1592 36.8849C44.9336 36.4495 45.3933 35.6266 45.3933 34.7312V13.2427C45.3933 12.3474 44.9336 11.5246 44.1592 11.0892L25.5261 0.344739C24.7518 -0.115137 23.808 -0.115137 23.0578 0.344739L4.42506 11.0892C3.62622 11.5246 3.1665 12.3474 3.1665 13.2427V34.7553C3.1665 35.1911 3.26333 35.6025 3.50531 35.9896Z"
          fill="#009639"
        />
        <path
          d="M18.315 32.1904C18.3163 32.5053 18.2552 32.8175 18.1353 33.1087C18.0154 33.4 17.839 33.6646 17.6162 33.8873C17.3935 34.1101 17.1289 34.2865 16.8376 34.4064C16.5464 34.5263 16.2342 34.5874 15.9192 34.5861C15.6043 34.5874 15.2922 34.5263 15.0009 34.4064C14.7097 34.2864 14.4451 34.11 14.2224 33.8873C13.9997 33.6646 13.8233 33.3999 13.7033 33.1087C13.5834 32.8174 13.5224 32.5053 13.5237 32.1904V15.7595C13.5237 14.4769 14.661 13.4364 16.2338 13.4364C17.3713 13.4364 18.7023 13.8961 19.5008 14.8882L20.2265 15.7595L30.245 27.7377V15.8078C30.2437 15.4929 30.3047 15.1807 30.4247 14.8895C30.5446 14.5982 30.721 14.3336 30.9437 14.1108C31.1665 13.8881 31.4311 13.7117 31.7224 13.5918C32.0136 13.4718 32.3258 13.4108 32.6407 13.4121C32.9557 13.4108 33.2678 13.4719 33.5591 13.5918C33.8503 13.7118 34.1149 13.8882 34.3376 14.1109C34.5603 14.3336 34.7367 14.5982 34.8566 14.8895C34.9766 15.1808 35.0376 15.4929 35.0363 15.8078V32.2388C35.0363 33.5213 33.899 34.5618 32.3262 34.5618C31.1887 34.5618 29.8577 34.1021 29.0592 33.1099L18.315 20.2845V32.1904Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2332_1999">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
